module.exports = __webpack_public_path__ + "assets/e6c2472eba8224cd69652e6368ba2b7f.mp3";